var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mx-5",attrs:{"fluid":""}},[_c('v-card',{staticClass:"mx-auto",attrs:{"elevation":"5","max-width":"1000px"}},[_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }